// extracted by mini-css-extract-plugin
export var truncate = "_v-0";